/**
 * SEO component that queries for data with
 * Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/
 */

import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"

const Seo = ({ description, lang, meta, title,image = '', pageUrl, siteUrl, post, schemaType = false }) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            social {
              twitter
            }
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description
  const defaultTitle = site.siteMetadata?.title

  let jsonld = false
  if ( schemaType === 'blog' ) {
    jsonld = {
      "@context": "http://schema.org",
      "@type": "BlogPosting",
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": `${pageUrl}`
      },
      "url": `${pageUrl}`,
      "articleSection": `${post.frontmatter.category}`,
      "headline": `${post.frontmatter.title}`,
      "description": `${post.frontmatter.description}`,
      "image": [
        `${image}`
      ],
      "datePublished": `${post.frontmatter.date}`,
      "dateModified": `${post.frontmatter.lastmod}`,
      "author": {
        "@type": "Person",
        "name": "takeshi sugimori",
        "url": "https://twitter.com/takeshi_du"
      },
      "publisher": {
        "@type": "Organization",
        "name": "Designup"
      }
    }
  } else if ( schemaType === 'product' ) {
    jsonld = {
      "@context": "https://schema.org/",
      "@type": "Product",
      "name": `${post.frontmatter.title}`,
      "image": [
        `${image}`
       ],
      "description": `${post.frontmatter.description}`,
      "sku": `${post.frontmatter.item_name}`,
      "brand": {
        "@type": "Brand",
        "name": "Designup"
      },
      "review": {},
      "aggregateRating": {},
      "offers": {
        "@type": "Offer",
        "url": `${pageUrl}`,
        "priceCurrency": "JPY",
        "price": `${post.frontmatter.price}`,
        "priceValidUntil": `${post.frontmatter.date}`,
        "itemCondition": "https://schema.org/NewCondition",
        "availability": "https://schema.org/InStock"
      }
    }
  }

  return (
    <>
      <title>{defaultTitle ? `${title} | ${defaultTitle}` : title}</title>
      <link rel="canonical" href={pageUrl} />
      <meta name="description" content={metaDescription} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary" />

      <meta
        name="twitter:creator"
        content={site.siteMetadata?.social?.twitter || ``}
      />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={image} />
      <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png"/>
      <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png"/>
      <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png"/>
      <link rel="manifest" href="/site.webmanifest"/>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
      <link href="https://fonts.googleapis.com/css2?family=Roboto+Condensed:wght@700&display=swap" rel="stylesheet" />
      {jsonld !== false && (
        <script type="application/ld+json">
        {JSON.stringify(jsonld)}
        </script>
      )}
    </>
  )
}

export default Seo
